import { BRAND } from '@/constants'
import { BrandName } from '@/scopes/common/domain/types'

export default function getBrandNameForServiceDescription(brandName: BrandName): string {
  return { [BRAND.SUNWEB]: 'Sunweb' }[brandName]
}
